import { Heading } from "@chakra-ui/react";

export function ErrorPage() {
  return <Heading>Ocorreu um erro.</Heading>;
}
